<template>
    <div class="user-center-box" v-show="init">
        <div class="user-center-content" v-show="!onSel">
            <ul class="wx-list">
                <li class="wx-link user-avatar"  id="user_pic">
                    <label>头像</label>
                    <span class="avatar"><img v-show="user.picStr" :src="user.picStr"><img v-show="!user.picStr" :src="header[user.sex%2]"></span>
                </li>
                <li>
                    <label>真实姓名</label>
                    <input name="name" :value="user.name" placeholder="请填写真实姓名" readonly unselectable="on" onfocus="this.blur()">
                </li>
               <li class="wx-link" :class="{empty:!user.sexName}"  @click="onSelGender">
                    <label>性别</label>
                    <input name="sex" type="hidden" :value="user.sex">
                    <span class="gander" v-show="user.sex == 0 || user.sex == 1" :class="{male: user.sex == 0, female: user.sex == 1}" ></span>
                    <input id="sex" v-show="user.sex != 0 && user.sex !=1 " placeholder="请选择性别" readonly unselectable="on" onfocus="this.blur()">
                    <span class="warn-msg">{{user.sexName}}保存后不可更改，请谨慎选择</span>
                </li>
                <li class="wx-link tel-link" @click="goModify">
                    <label>手机号码</label>
                    <input name="phone" type="tel" :value="user.phone" placeholder="请填写手机号码" readonly unselectable="on" onfocus="this.blur()">
                </li>
            </ul>
            <ul class="wx-list">
                <li class="wx-link" :class="{empty:!user.schoolName}" @click="onSelSchool">
                    <label>学校</label>
                    <input name="schoolId" type="hidden" :value="user.schoolId" >
                    <input id="schoolId" v-model="user.schoolName" placeholder="请选择学校" readonly unselectable="on" onfocus="this.blur()">
                    <span class="warn-msg">保存后不可更改，请谨慎选择</span>
                </li>
               <li class="wx-link" :class="{empty:!user.organizationName}" @click="onSelCollage">
                    <label>院系</label>
                    <input name="organizationId" type="hidden" :value="user.organizationId" >
                    <input id="collageId" v-model="user.organizationName" placeholder="请选择院系" readonly unselectable="on" onfocus="this.blur()">
                    <span class="warn-msg">保存后不可更改，请谨慎选择</span>
                </li>

                <li class="wx-link" :class="{empty:!user.className}" @click="onSelClass">
                    <label>班级</label>
                    <input name="classId" type="hidden" :value="user.classId">
                    <input id="classId" :value="user.className" placeholder="请选择班级" readonly unselectable="on" onfocus="this.blur()">
                    <span class="warn-msg">保存后不可更改，请谨慎选择</span>
                </li>
                <li>
                    <label>学号</label>
                    <input name="staffNumber" :value="user.staffNumber" placeholder="请填写学号" readonly unselectable="on" onfocus="this.blur()">
                </li>
            </ul>
            <ul class="wx-list">
                <li class="wx-link account-link" @click="goAccount">
                    <label>切换账号</label>
                    <span class="msg">点击切换账号</span>
                </li>
            </ul>
            <ul class="wx-list">
                <li class="wx-link unlock" @click="onUnlock">
                    <label>解除绑定</label>
                    <span class="msg">解除绑定</span>
                </li>
            </ul>
            <!-- <ul class="wx-list">
                <li class="wx-link" @click="scan">
                    <label>意见建议</label>
                </li>
            </ul> -->
            <div class="btn-wrapper">
                <a href="javascript:void(0);" class="btn-commit" @click="save" >保存</a>
            </div>
        </div>
        <div class="collage-box" v-show="onSel">
            <div class="search-box-wrap">
                <div class="search-box">
                    <input  v-model="key" name="" placeholder="选择院系" >
                    <span class="ico-clear" @click="searchClear"></span>
                </div>
            </div>
            <ul class="list-panel">
                <li class="item" v-for="organization in search(key)" @click="selCollage(organization)">{{organization.name}}</li>
            </ul>
        </div>
        <v-footer></v-footer>
        <v-uploader
            type="single"
            :btnId="btnId"
            @imgUploadCallback="modifyPic">
        </v-uploader>
    </div>
</template>

<script>
    import footer from '@/components/student/include/footer-syx.vue';
    import * as center  from '../../../../static/js/user/center.js';
    import * as cookieUtil from '@static/js/cookieUtil.js';
    import { dialog } from '@static/js/util.js';
    import userType from '@data/AppTypeData'
	export default{
		data(){
			return{
                header: ["../../static/images/default-header/man-student.png","../../static/images/default-header/girl-student.png"],
                init : false,//页面是否加载完成
                onSel : false,
                genders : [
                    {key : userType.SEX_TYPE.MALE, name : '男'},
                    {key : userType.SEX_TYPE.FEMALE, name : '女'},
                ],
                schools : [],
                organizations : [],
                classes : [],
                user : {},
                loadUrl : '',
                key : '',
                list : [],
                btnId : 'user_pic'
			}
		},
		components: {
			"v-uploader": function (resolve) {
				require(['../../include/uploader'], resolve)
            },
            "v-footer": footer
        },
		methods:{
            onUnlock : function(){
                var _this = this;
                 this.$confirm('解除绑定之后，无法再用微信登录当前账号', '', ()=>{
                  this.unlock()
                }, ()=>{})
                // dialog({html:"解除绑定之后，无法再用微信登录当前账号",confirmCallBack:()=>{ _this.unlock(); },arr:['信息','close','取消','确认']});
            },
            unlock : function(){
                this.pauseLoop()
                var _this = this;

                _this.loading = weui.loading('正在提交');
                _this.$axios.post(_this.stuApiUrl + "/student/unbind", _this.$qs.stringify({})).then(function (response) {
                    _this.loading.hide();
                    if(!response.data.success){
                        return weui.alert(response.data.info);
                    }
                    cookieUtil.delCookie("SC_COOKIE_URL");
                    cookieUtil.delCookie('SC_SIGN');
                    cookieUtil.delCookie('SC_JOIN');

                    cookieUtil.delCookie('SC_COOKIE_USER_ID');
                    cookieUtil.delCookie("SC_WX_USER_COOKIE");
                    if (!response.data.existBind){
                        window.sessionStorage.removeItem("SC_USER");
                    }

                    weui.toast('解除成功', {
                        duration: 2000,
                        className: 'custom-classname',
                        callback: function(){
                            _this.$router.replace('/auth');
                        }
                    });
                }).catch(function (error) {
                    _this.loading.hide();
                    console.log(error);
                });
            },
            goAccount: function(){
                this.$router.push('/account');
            },
             searchClear : function(){
				this.key = '';
            },
            search : function(keywords){
                return this.organizations.filter(item => {
                    if (item.name.includes(keywords)) {
                        return item;
                    }
                })
            },
			goModify: function () {
				var tel = this.user.phone || 'unset';
				this.$router.push('/student/user/validate-phone/' + tel);
			},
			onSelGender : function(){
				var _this = this;
				var params = [];
				if(_this.user.sex == userType.SEX_TYPE.MALE || _this.user.sex == userType.SEX_TYPE.FEMALE){
					return;
				}
				for(var index in _this.genders){
					var item = _this.genders[index];
					params.push({
						label: item.name,
						value: item
					});
				}
				
				weui.picker(params,{
					defaultValue: [_this.user.sex],
					onChange: function (result) {
					},
					onConfirm: function (result) {
						var data = result[0].value;
						_this.user.sex = data.key;
						_this.user.sexName = data.name;
						_this.$forceUpdate();
					},
					id: 'genderPicker'
				});
			},
			onSelSchool : function(event,type){
				if(this.user.schoolId > 0){
					return;
				}
				var _this = this;
				if(_this.schools.length < 1 ){
					_this.$axios.post(_this.stuApiUrl + "/school/list", _this.$qs.stringify({}))
						.then(function (response) {
							if (!response.data.success) {
								return weui.alert(response.data.info);
							}
							_this.schools = response.data.school;
							_this.selSchool();
						}).catch(function (error) {
						console.log(error);
					});
				} else {
					_this.selSchool();
				}
			},
			selSchool : function(){
				var _this = this;
				var params = [];
				for(var index in _this.schools){
					var item = _this.schools[index];
					params.push({
						label: item.name,
						value: item
					});
				}
				weui.picker(params,{
					defaultValue: [_this.user.schoolId],
					onChange: function (result) {
					},
					onConfirm: function (result) {
						var data = result[0].value;
						_this.user.schoolId = data.id;
						_this.user.schoolName = data.name;
						_this.$forceUpdate();
					},
					id: 'singleLinePicker'
				});
			},
			onSelCollage : function(event,type){
				var _this = this;
			
				if(this.user.schoolId == 0){
					return weui.alert('请先选择学校');
				}
				if(this.user.organizationId > 0){
					return;
				}else{
					_this.$axios.post(_this.stuApiUrl + "/organization/query-all", _this.$qs.stringify({}))
						.then(function (response) {
							if(!response.data.success){
								return weui.alert(response.data.info);
							}
							var organizationsMap = response.data.organizations;
							var organizations = [];
							for(var key in organizationsMap){
								organizations.push({
									id : key,
									name : organizationsMap[key]
								});
							}
							_this.organizations = organizations;
							_this.onSel = true;
						}).catch(function (error) {
						console.log(error);
					});
				}
			
			},
			selCollage : function(organization){
				var _this = this;
				this.onSel = false;
				_this.user.organizationId = organization.id;
				_this.user.organizationName = organization.name;
			},
			onSelClass : function(event,type){
				if(this.user.classId > 0){
					return;
				}
				var _this = this;
				if(_this.classes.length < 1 ){
					_this.$axios.post(_this.stuApiUrl + "/class/list", _this.$qs.stringify({}))
						.then(function (response) {
							if(!response.data.success){
								return weui.alert(response.data.info);
							}
							_this.classes = response.data.class;
							_this.selClass();
						}).catch(function (error) {
						console.log(error);
					});
				}else{
					_this.selClass();
				}
			},
			selClass : function(){
				var _this = this;
				var params = [];
				for(var index in _this.classes){
					var item = _this.classes[index];
					params.push({
						label: item.name,
						value: item
					});
				}
				if(params.length == 0){
					return weui.alert('当前学校未配置班级');
				}
				weui.picker(params,{
					defaultValue: [_this.user.classId],
					onChange: function (result) {
					},
					onConfirm: function (result) {
						var data = result[0].value;
						_this.user.classId = data.id;
						_this.user.className = data.name;
						_this.$forceUpdate();
					}
				});
			},

            
           
            


			// 该方法用于保存对应修改数据
            save : function(){
                var _this = this;
                _this.loading = weui.loading('正在提交');
                _this.$axios.post(_this.stuApiUrl + "/student/update", _this.$qs.stringify({
                    sex:_this.user.sex,
                    classId:_this.user.classId,
                    organizationId:_this.user.organizationId
                })).then(function (response) {
                    _this.loading.hide();
                    if(!response.data.success){
                        return weui.alert(response.data.info);
                    }
                    weui.toast('保存成功');
                }).catch(function (error) {
                    _this.loading.hide();
                    console.log(error);
                });
            },
            // Long organizationId, Long classId, Byte sex,
            loadData : function(){
                var _this = this;
                _this.loading = weui.loading('正在加载');
                _this.$axios.post(_this.stuApiUrl + "/student/info", _this.$qs.stringify({}))
                .then(function (response) {
                    _this.loading.hide();
                    if(!response.data.success){
                        return weui.alert(response.data.info);
                    }

                    _this.user = response.data.student;
                    var gender = {
                        "0":"男",
                        "1":"女"
                    };
                    _this.user.sexName = gender[_this.user.sex];
                    _this.init = true;
                }).catch(function (error) {
                    _this.loading.hide();
                });
            },
            modifyPic:function(pic,picUrl){
            	var _this = this;
                _this.$axios.post(_this.stuApiUrl + "/student/modify-pic",
                _this.$qs.stringify({pic:picUrl}))
                .then(function (response) {
                	if(!response.data.success){
	                	return weui.alert(response.data.info);
                    }
                    weui.toast('编辑成功');
                	_this.user.picStr = picUrl;
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
		mounted(){
            var height = $('.user-center-box').height();
            $('.user-center-box').height(height);
            this.loadData();
		},
		beforeDestroy() {
		},
		destroyed() {
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../../static/css/student/user/center.css';
.user-center-box{
    height: 100%;
    padding-bottom: 1rem;
    box-sizing: border-box;
}

.user-center-content{
    height: 100%;
    overflow: auto;
}

.avatar{
    width: .8rem;
    height: .8rem;
    float: right;
    margin-top: .2rem;
    overflow: hidden;
    border-radius: .4rem;
}

.avatar img{
    width: .8rem;
    height: .8rem;
    object-fit: cover;
}

.warn-msg{
    position: absolute;
    bottom: .2rem;
    right: .7rem;
    font-size: .26rem;
    color: #c93d25;
    line-height: 1.1;
    display: none;
}
.empty{
    position: relative;
}
.empty input{
    line-height: .8rem;
}
.empty .warn-msg{
    display: block;
}

.gander{
    float: right;
    width: 1.2rem;
    height: 1.18rem;
    background-color: transparent;
    background-position: right center;
    background-repeat: no-repeat;
}

.gander.male{
    background-image: url("../../../../static/images/boy@3x.png");
    background-size: .28rem .27rem;

}

.gander.female{
    background-image: url("../../../../static/images/girl@3x.png");
    background-size: auto .27rem;
}

.collage-box{
	height: 100%;
	overflow: auto;
}

.btn-wrapper{
    padding: .4rem .2rem;
}

.wx-list{
    padding-left: 0.34rem;
    box-sizing: border-box;
    border-bottom: 0.01rem solid #EDEEF2;
    margin: 0 0 0.2rem 0;
    background-color: #fff;
    font-size: .3rem;
}
.wx-list li{
    line-height: 1.2rem;
    border-bottom: 0.01rem solid #EDEEF2;
    padding-right: .7rem;
    text-align: left;
}

.wx-list li:last-child{
    border: none;
}
.wx-list li.wx-link{
    background-image: none;
}

.wx-list li input,.wx-list li span.msg{
     border: none;
    float: right;
    max-width: 3rem;
    line-height: 1.18rem;
    text-align: right;
    font-size: .3rem;
}

.wx-list li input{
    color: #000;
}

.wx-list li span.msg{
    color: #b8bacc;
}

.wx-list li.wx-link.empty{
    background-image: url("../../../../static/images/page@3x.png");
}
.wx-list li.wx-link.user-avatar{
    background-image: url("../../../../static/images/page@3x.png");
}
.wx-list li.wx-link.tel-link{
    background-image: url("../../../../static/images/page@3x.png");
}
.wx-list li.wx-link.account-link{
    background-image: url("../../../../static/images/page@3x.png");
}

.btn-commit{
    line-height: 1rem;
    color: #fff;
    text-align: center;
    background: rgba(21, 192, 188, 1);
    /* background: #cccccc; */
    border-radius: 0.08rem;
    width: 7.1rem;
    line-height: 0.96rem;
    font-size: .32rem;
    margin: auto;
    /* margin-top: .6rem; */
    display: block;
    position: relative;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/student/user/center.vue